import { DataWithPagination, TBaseProject } from '@/core/types'
import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
} from '@/core/utils'
import { TCoOwners } from '../co-owners'
import {
  TBudget,
  TCatalog,
  TCoOwnership,
  TLot,
  TProject,
  TStatus,
} from './types'

export type TProjects = DataWithPagination<TBaseProject>

export type TCoOwnerships = DataWithPagination<TCoOwnership>

export type TLots = DataWithPagination<TLot>

export type TBudgets = DataWithPagination<TBudget>

export type TStatuses = TStatus[]

export type TCatalogs = TCatalog[]

export const serviceConfig = {
  model: 'projects',
  version: 'v1',
  coOwnerships: {
    model: 'co-ownerships',
    version: 'v1',
  },
  coOwners: {
    model: 'co-owners',
    version: 'v1',
  },
  lots: {
    model: 'lots',
    version: 'v1',
  },
  projectStatus: {
    model: 'projects/status',
    version: 'v1',
  },
  projectTypes: {
    model: 'project-types',
    version: 'v1',
  },
  lotsStatus: {
    model: 'lots/status',
    version: 'v1',
  },
  budgets: {
    model: 'budgets',
    version: 'v1',
  },
}

const {
  coOwnerships,
  coOwners,
  lots,
  projectStatus,
  projectTypes,
  lotsStatus,
  budgets,
} = serviceConfig

const moduleServiceHandlers = createCrudEndpoints<TProjects, TProject>(
  serviceConfig.model,
  serviceConfig.version,
)

const coOwnersCatalogService = createCatalogEndpoint<TCoOwners>(
  coOwners.model,
  coOwners.version,
)

const coOwnershipNestedService = createNestedCrudEndpoints<
  TCoOwnerships,
  TCoOwnership
>(serviceConfig.model, coOwnerships.model, coOwnerships.version)

const lotsService = createNestedCrudEndpoints<TLots, TLot>(
  serviceConfig.model,
  lots.model,
  lots.version,
)

const projectStatusService = createCatalogEndpoint<TStatuses>(
  projectStatus.model,
  projectStatus.version,
)

const projectsTypesService = createCatalogEndpoint<TCatalogs>(
  projectTypes.model,
  projectTypes.version,
)

const lotStatusService = createCatalogEndpoint<TCatalogs>(
  lotsStatus.model,
  lotsStatus.version,
)

const budgetsService = createNestedCrudEndpoints<TBudgets, TBudget>(
  serviceConfig.model,
  budgets.model,
  budgets.version,
)

export {
  coOwnersCatalogService,
  coOwnershipNestedService,
  lotsService,
  moduleServiceHandlers,
  projectStatusService,
  projectsTypesService,
  lotStatusService,
  budgetsService,
}
